export const items = [
  { label: 'Current Pool' },
  { label: 'Delegations' },
  { label: 'Blocks Proposed' },
]
